import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useSearchParams } from 'react-router-dom'

import { LocalFile, ZoneType } from '@types'

import { useModal } from '@hooks/app/modal.hook'

import { Modal } from '@components/Modal'
import { Input } from '@components/Input'
import { TextArea } from '@components/TextArea'

import { useCreateZone } from '@hooks/zone/create-zone.hook'

import { Container } from './add-floor.styled'
import { UploadFile } from '@components/UploadFile'

export const AddFloorPage = (): JSX.Element => {
  const { hideModal } = useModal()

  const { t } = useTranslation()

  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [plans, setPlans] = useState<LocalFile[]>([])

  const { createZone } = useCreateZone()

  const [searchParams] = useSearchParams()

  const { projectId } = useParams()
  const buildingId = searchParams.get('buildingId')

  return (
    <Modal
      title={t('modules_project-settings_pages_add_floor_title')}
      onSubmitLabel={t('modules_project-settings_pages_add_floor_button_add-floor')}
      onClose={() => {
        hideModal('add_floor')
      }}
      onSubmit={() => {
        if (projectId && buildingId) {
          createZone(
            {
              projectId,
              parentId: buildingId,
              name,
              description,
              type: ZoneType.Floor,
            },
            plans,
          )

          hideModal('add_floor')
        }
      }}
    >
      <Container>
        <Input
          autoFocus
          required
          label={t('modules_project-settings_pages_add_floor_label_floor-name')}
          placeholder={t('modules_project-settings_pages_add_floor_placeholder_floor-name')}
          value={name}
          onChange={(v) => setName(v)}
        />
        <TextArea
          label={t('modules_project-settings_pages_add_floor_label_description')}
          placeholder={t('modules_project-settings_pages_add_floor_placeholder_description')}
          value={description}
          onChange={(v) => setDescription(v)}
        />
        <UploadFile
          label={t('modules_project-settings_pages_add_floor_label_floor_plans')}
          labelUpload={t('modules_project-settings_pages_manage_zones_label_upload_plans')}
          files={plans}
          setFiles={(plans) => setPlans(() => [...plans] as LocalFile[])}
        />
      </Container>
    </Modal>
  )
}
